import { authQueryKeys, useMeQuery } from '@entities/auth'
import { clearAccessToken } from '@shared/api/client'
import { removeLastProvider } from '@shared/lib/last-provider'
import { usePollingStore } from '@shared/store/use-polling-store'
import { useQueryClient } from '@tanstack/react-query'

export function useAuth() {
  const { data, isLoading } = useMeQuery()
  const queryClient = useQueryClient()

  function clearAuth() {
    clearAccessToken()
    removeLastProvider()
    queryClient.removeQueries({ queryKey: authQueryKeys.me() })
    usePollingStore.getState().reset()
  }

  return { user: data, isLoggedIn: !!data, isLoading, clearAuth }
}
